import { render, staticRenderFns } from "./ListaEventi.vue?vue&type=template&id=58038003&scoped=true&"
import script from "./ListaEventi.vue?vue&type=script&lang=js&"
export * from "./ListaEventi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58038003",
  null
  
)

export default component.exports